// extracted by mini-css-extract-plugin
module.exports = {"siteWrapper":"styles_siteWrapper__otYy3"};